import { render, staticRenderFns } from "./Cod.vue?vue&type=template&id=b2a08b12&scoped=true&"
import script from "./Cod.vue?vue&type=script&lang=js&"
export * from "./Cod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a08b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a08b12')) {
      api.createRecord('b2a08b12', component.options)
    } else {
      api.reload('b2a08b12', component.options)
    }
    module.hot.accept("./Cod.vue?vue&type=template&id=b2a08b12&scoped=true&", function () {
      api.rerender('b2a08b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Cod/Cod.vue"
export default component.exports